// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ISoftwareVersion} from '../../../../types/subscription';
import {IInvitationResponse} from '../../../../types/user';
import {ActionService} from '../../../../services/action-service';
import { ConfigurationService } from '../../../../services/configuration-service';
import { TranslateService } from '@ngx-translate/core';

export function getDownloadFilename(version: ISoftwareVersion, sub_id: string = ''): string {
  const parts: string[] = version.path.split('/');
  const filename: string = parts[parts.length - 1];
  const dotParts = filename.split('.');
  dotParts.pop();
  const basename = dotParts.join('.');

  return `${basename}_${sub_id}_${version.system}.exe`;
}

export interface IWelcomeDialogConfig {
  version: ISoftwareVersion;
  invitationResponse: IInvitationResponse;
}

@Component({
    selector: 'app-welcome',
    templateUrl: './welcome.component.html',
    styleUrls: ['./welcome.component.scss'],
    standalone: false
})
export class WelcomeComponent {
  headerText: string;
  verifyText: string;
  inviteA: string;
  inviteB: string;

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: IWelcomeDialogConfig,
      private actionService: ActionService,
      private translate: TranslateService,
      private configuration: ConfigurationService
  ) {
      const translatePostfix = this.configuration.translatePostfix;
      this.headerText = this.translate.instant('W_HEADER' + translatePostfix);
      this.verifyText = this.translate.instant('W_VERIFY' + translatePostfix);
      this.inviteA = this.translate.instant('W_INVITEA' + translatePostfix);
      this.inviteB = this.translate.instant('W_INVITEB' + translatePostfix);
  }

}
